import {Text} from "@fluentui/react-components"
import * as React from "react";
import Content from "../domain/Content";
import NotificationItem from "./NotificationItem";

export interface INotificationsProps {
    newNotifications?: Content[];
    previousNotifications?: Content[];
    organizationName?: string;
    onReadMore: (content: Content) => void;
    onDismiss: (content: Content) => void;
}
export default function Notifications (props: INotificationsProps){

    function render() {
        if ((!props.newNotifications || props.newNotifications.length === 0) && (!props.previousNotifications || props.previousNotifications.length === 0) ) {
            const organizationName = props.organizationName ? ` from ${props.organizationName}.` : ".";
            return (
                <div className="smt-flex smt-filled smt-flex__dir_column smt-flex__gap-2 smt-flex__jc-center" style={{marginTop: "60px"}}>
                    <Text size={400} weight="semibold">You're all caught up</Text>
                    <Text size={300} color="grey">Check back later for more updates{organizationName}</Text>
                </div>
            );
        }

        let newNotificationJSX: JSX.Element[] = [];
        let previousNotificationJSX: JSX.Element[] = [];

        if (props.newNotifications && props.newNotifications.length > 0) {
            newNotificationJSX = props.newNotifications.map((curItem: Content) => {
               return (<NotificationItem content={curItem} key={"noti" + curItem.postId} onDismiss={props.onDismiss} onReadMore={props.onReadMore} />);
            });
        }

        if (props.previousNotifications && props.previousNotifications.length > 0) {
            previousNotificationJSX = props.previousNotifications.map((curItem: Content) => {
                return (<NotificationItem content={curItem} key={curItem.postId} onDismiss={props.onDismiss} onReadMore={props.onReadMore} />);
            });
        }

        return (
            <React.Fragment>
                {
                    newNotificationJSX.length > 0 &&
                    (
                        <React.Fragment>
                            <Text size={400} weight="semibold" style={{marginBottom: "24px" }}>New</Text>
                            {newNotificationJSX}
                        </React.Fragment>

                    )
                }

                {
                    previousNotificationJSX.length > 0 &&
                    (
                        <React.Fragment>
                            <Text size={400} weight="semibold" style={{marginBottom: "24px" }}>Previous</Text>
                            {previousNotificationJSX}
                        </React.Fragment>

                    )
                }
            </React.Fragment>
        );

    }

    return render();
}
